export default {
      id: "logo-eu-usage",
      viewBox: "0 0 357 100",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-eu",
      toString: function () {
        return this.url;
      }
    }